import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Message } from 'semantic-ui-react';
import axios from 'axios';
import ProfileLatestTweets from './profile-latest-tweets';
import ProfileLatestYoutubeVideos from './profile-latest-youtube-videos';
import ProfileLatestInstagrams from './profile-latest-instagrams';
import ProfileLatestTiktoks from './profile-latest-tiktoks';

class InfluencerLatest extends Component {
  static propTypes = {
    influencer: PropTypes.object,
  };

  static defaultProps = {
    influencer: {},
  };

  constructor() {
    super();
    this.state = {
      instagramData: null,
      twitterData: null,
      youtubeData: null,
      tiktokProfileData: null,
      tiktok: null,
      loading: false,
      tiktokLoading: false,
    };
  }

  componentDidMount() {
    const { instagramId, twitter, youtube, tiktokProfileData, tiktok, statisticsUpdatedDate } = this.props.influencer;

    if (tiktokProfileData) {
      tiktokProfileData.statisticsUpdatedDate = statisticsUpdatedDate;
      this.setState({
        tiktokProfileData,
        tiktok,
        tiktokLoading: true,
      });
    }

    this.setState({
      loading: true,
    });


    axios({
      method: 'post',
      url: process.env.REACT_APP_INFLUENCER_GET_LATEST_POSTS_URL,
      data: {
        instagramId,
        twitter,
        youtube,
      },
    })
      .then(response => {
        this.setState({
          instagramData: response.data.body.instagram,
          twitterData: response.data.body.twitter,
          youtubeData: response.data.body.youtube,
          loading: false,
        });
      })
      .catch(error => console.log(error));

    axios({
      method: 'get',
      url: `https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/tiktok/rapid/posts/user/${tiktok}`,
    })
      .then(response => {
        console.log(response.data);
        this.setState({
          tiktokProfileData: response.data,
          tiktokLoading: false,
        });
      })
      .catch(error => console.log(error));
  }

  render() {
    const { instagramData, twitterData, youtubeData, tiktokProfileData, tiktok, loading, tiktokLoading } = this.state;

    if (loading) {
      return (
        <h2 className="page-content">Loading...</h2>
      );
    }

    const { influencer } = this.props;

    if (_.eq(_.get(influencer, 'instagramPrivate', false), true)) {
      return (
        <div className="page-content">
          <Message
            warning
            icon="lock"
            header="Private account"
            content="This Instagram account is private"
          />
        </div>
      );
    }

    if (instagramData || twitterData || youtubeData || tiktokProfileData) {
      return (
        <div className="page-content">
          {youtubeData && youtubeData.length > 0 && <ProfileLatestYoutubeVideos youtubeVideos={youtubeData} />}
          {_.get(instagramData, 'data') && instagramData.data.length > 0 && <ProfileLatestInstagrams instagrams={instagramData} influencer={this.props.influencer} />}
          {tiktok && tiktokProfileData && <ProfileLatestTiktoks tiktokProfileData={tiktokProfileData} tiktokLoading={tiktokLoading} />}
          {twitterData && twitterData.length > 0 && <ProfileLatestTweets tweets={twitterData} />}
        </div>
      );
    }

    return (
      <div className="page-content">
        <Message>
          <p>We couldn’t load any recent posts from this influencer.</p>
        </Message>
      </div>
    );
  }
}

export default InfluencerLatest;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-latest/index.js
 **/